<template>
    <section>
        <header class="my-2 border-bottom" v-if="serviceType">
            <h5 class="title" :class="[panelClass(serviceType)]">
                {{ serviceType.label }}
                <div class="float-right">
                    <button type="button" class="btn btn-xs btn-secondary" @click="$emit('add-new-detail', serviceType)">
                        <i class="mdi mdi-plus"></i>
                        Add New
                    </button>
                </div>
            </h5>
        </header>

        <article v-if="invoice">
            <invoices-details-item-edit v-for="(detail, index) in groupDetails(serviceType)"
                :key="index"
                :iterator="iterator(detail)"
                :detail="detail"
                :services="serviceType.services">
            </invoices-details-item-edit>

        </article>
    </section>
</template>

<style type="text/css">
    .text-bolder{
        font-weight: bolder
    }
</style>

<script>

import InvoiceDetailEdit from './detail/Edit'

export default {
    /**
     * @type {String} Component Name
     */
    name: 'invoice-detail-panel',

    /**
     * The components the page can use.
     */
    components: {
        InvoiceDetailEdit,
    },

    /**
     * @type {Array} List passable properties
     */
    props: [
        'invoice',
        'serviceType',
    ],

    /**
     * @returns {Object} The view-model data.
     */
    data() {
        return {};
    },

    /**
     * Register the observer
     *
     * @type {Object}
     */
    watch:{
        /*invoice: {
            deep:true,
        }*/
    },

    /**
     * Prepare the component.
     */
    created() {
    },

    /**
     * Mounted the component.
     */
    mounted() {
    },

    /**
     * Clean after the component is destroyed.
     */
    destroyed(){
    },

    /**
     * Components computed values
     * For example: value : function(){},
     *
     * @type {Object}
     */
    computed: {
        details: function(){
            return this.invoice.details
        },

        loaded: function(){
            return this.invoice && this.serviceType
        },
    },

    /**
     * Components computed values
     * Each element is a function()
     *
     * @type {Object}
     */
    methods:{
        /**
         * @param  {ServiceType} serviceType
         * @return {array} Group the details by their type
         */
        groupDetails(serviceType){
            return _.filter(this.details, {
                service_type_id:serviceType.id
            })
        },

        /**
         * @param  {ServiceType} serviceType
         * @return {int} Number of details in current invoice that are of that specific type
         */
        detailCount: function(serviceType){
            return this.groupDetails(serviceType).length
        },

        /**
         * @return {boolean} True if the invoide detail has a at least one $serviceType
         */
        notEmpty(serviceType){
            return this.detailCount(serviceType) > 0
        },

        /**
         * @return {Object} Change style of lines if there are elements
         */
        panelClass: function(serviceType){
            return {
                'text-bolder': this.notEmpty(serviceType)
            }
        },

        /**
         * Count true iterator index
         *
         * @param  {Object} item
         * @return {int}
         */
        iterator: function(item){
            return _.findIndex(this.details, item)
        },
    }
};
</script>




// WEBPACK FOOTER //
// resources/js/components/invoice/Panel.vue